import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats numbers as USD. Negatives display as ($100.00) instead of -$100.00.
 */
@Pipe({
    name: 'statementAmount',
    standalone: false
})
export class StatementAmountPipe implements PipeTransform {
    private static readonly formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    transform(value: number | null | undefined): string {
        if (value == null || (typeof value === 'number' && isNaN(value))) {
            return '$0.00';
        }
        const n = Number(value);
        const formatted = StatementAmountPipe.formatter.format(Math.abs(n));
        return n < 0 ? `(${formatted})` : formatted;
    }
}
